import { IEvent } from '../../Interfaces/IEvent';

export const ajaxStatusActions = {
  BEGIN_AJAX_CALL: 'BEGIN_AJAX_CALL',
  END_AJAX_CALL: 'END_AJAX_CALL',
};

export const beginAjaxCall = (): IEvent => ({
  type: ajaxStatusActions.BEGIN_AJAX_CALL,
});

export const endAjaxCall = (): IEvent => ({
  type: ajaxStatusActions.END_AJAX_CALL,
});
